export enum EffectWorkKind {
  /// <summary>
  /// کارکردی
  /// </summary>
  Work = 1,
  /// <summary>
  /// مرخصی
  /// </summary>
  Leave = 2,
  /// <summary>
  /// موردی
  /// </summary>
  OtherValue = 3,
}
